// Uno Party Card Game Client
import { sounds } from '../sound.js';

export class UnoCardClient {
  constructor(socket, containerEl) {
    this.socket = socket;
    this.container = containerEl;
    this.myHand = [];
    this.topCard = null;
    this.currentColor = 'red';
    this.currentTurnId = null;

    this.render();
    this.setupSocketEvents();
  }

  render() {
    this.container.innerHTML = `
      <div class="uno-wrapper">
        <div class="uno-header">
          <h2>🃏 UNO PARTY BATTLE</h2>
          <div id="uno-turn-badge" class="uno-badge">Waiting for game...</div>
        </div>

        <!-- Discard Pile & Draw Deck -->
        <div class="uno-center-table">
          <div class="uno-deck" id="uno-draw-deck">
            <span class="deck-logo">UNO</span>
            <span class="deck-prompt">DRAW CARD</span>
          </div>

          <div class="uno-discard" id="uno-top-card">
            <!-- Rendered Top Card -->
          </div>

          <div class="uno-color-indicator" id="uno-color-indicator">
            CURRENT COLOR: <span id="uno-color-text" style="color: #ef4444;">RED</span>
          </div>
        </div>

        <!-- Other Players Hand Status -->
        <div class="uno-other-players" id="uno-players-list"></div>

        <!-- Player's Hand -->
        <div class="uno-hand-container">
          <div class="uno-hand" id="uno-my-hand"></div>
        </div>

        <!-- Wild Color Choice Modal -->
        <div id="uno-wild-modal" class="uno-wild-modal modal-hidden">
          <h3>CHOOSE A COLOR</h3>
          <div class="wild-color-row">
            <button class="btn-color red" data-color="red">RED</button>
            <button class="btn-color blue" data-color="blue">BLUE</button>
            <button class="btn-color green" data-color="green">GREEN</button>
            <button class="btn-color yellow" data-color="yellow">YELLOW</button>
          </div>
        </div>
      </div>
    `;

    document.getElementById('uno-draw-deck')?.addEventListener('click', () => {
      if (this.currentTurnId === this.socket.id) {
        sounds.playCard();
        this.socket.emit('uno_draw');
      }
    });

    document.querySelectorAll('.btn-color').forEach((btn) => {
      btn.addEventListener('click', () => {
        const color = btn.dataset.color;
        const modal = document.getElementById('uno-wild-modal');
        if (modal) modal.classList.add('modal-hidden');
        if (this.pendingWildIndex !== undefined) {
          sounds.playCard();
          this.socket.emit('uno_play', { cardIndex: this.pendingWildIndex, wildColor: color });
          this.pendingWildIndex = undefined;
        }
      });
    });
  }

  renderHand() {
    const handBox = document.getElementById('uno-my-hand');
    if (!handBox) return;
    handBox.innerHTML = '';

    this.myHand.forEach((card, idx) => {
      const el = document.createElement('div');
      el.className = `uno-card ${card.color}`;
      el.innerHTML = `
        <span class="card-corner top">${card.value}</span>
        <span class="card-val">${card.value}</span>
        <span class="card-corner bottom">${card.value}</span>
      `;
      el.addEventListener('click', () => this.playCard(idx, card));
      handBox.appendChild(el);
    });
  }

  playCard(idx, card) {
    if (this.currentTurnId !== this.socket.id) return;

    if (card.color === 'wild') {
      this.pendingWildIndex = idx;
      const modal = document.getElementById('uno-wild-modal');
      if (modal) modal.classList.remove('modal-hidden');
    } else {
      sounds.playCard();
      this.socket.emit('uno_play', { cardIndex: idx });
    }
  }

  setupSocketEvents() {
    this.socket.on('uno_hand', (data) => {
      this.myHand = data.hand;
      this.renderHand();
    });

    this.socket.on('uno_state', (data) => {
      this.topCard = data.topCard;
      this.currentColor = data.currentColor;
      this.currentTurnId = data.currentTurnId;

      const badge = document.getElementById('uno-turn-badge');
      const isMyTurn = this.currentTurnId === this.socket.id;
      if (badge) {
        badge.innerText = isMyTurn ? '👉 YOUR TURN!' : `Turn: ${data.currentTurnName}`;
        badge.style.color = isMyTurn ? '#22c55e' : '#38bdf8';
      }

      const topCardEl = document.getElementById('uno-top-card');
      if (topCardEl && this.topCard) {
        topCardEl.className = `uno-discard uno-card ${this.topCard.color}`;
        topCardEl.innerHTML = `<span class="card-val">${this.topCard.value}</span>`;
      }

      const colorText = document.getElementById('uno-color-text');
      if (colorText) {
        colorText.innerText = this.currentColor.toUpperCase();
        const colorsMap = { red: '#ef4444', blue: '#38bdf8', green: '#22c55e', yellow: '#eab308' };
        colorText.style.color = colorsMap[this.currentColor] || '#ffffff';
      }

      const playersList = document.getElementById('uno-players-list');
      if (playersList && data.handCounts) {
        playersList.innerHTML = data.handCounts.map(p => `
          <div class="uno-p-card ${p.id === this.currentTurnId ? 'active' : ''}">
            <span class="p-avatar">${p.avatar}</span>
            <span class="p-name">${p.name}</span>
            <span class="p-count">🎴 x${p.count}</span>
          </div>
        `).join('');
      }
    });

    this.socket.on('uno_gameOver', (data) => {
      sounds.playVictory();
      alert(`🏆 UNO CHAMPION: ${data.winner?.name || 'Player'} has won the match!`);
    });
  }

  destroy() {
    this.socket.off('uno_hand');
    this.socket.off('uno_state');
    this.socket.off('uno_gameOver');
  }
}
